import axios from 'axios'
import {useStore} from "vuex";
import { generateUrl } from 'xt-verification'

const instance = axios.create({
  // baseURL: 'https://app-survey.iqilu.com/api',
  // baseURL: 'http://10.0.117.186:8081',
  // baseURL: 'https://lottery.cq.qiludev.com/lottery-app/api',
  baseURL: 'https://app-hd.litenews.cn/lottery-app/api',
  timeout: 10000,
})

const store = useStore()

instance.interceptors.request.use((config) => {
  config.url = generateUrl({
    url: config.url,
    orgId: config.orgid,
    secret: 'c9qtnxf45ju112ndy8ggwql32dy1e8j7'
  })

  config.headers["CQ-TOKEN"] = config.token;
  config.headers["orgid"] = config.orgid;

  return config
})

export const get = (url, params, config) => {

  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params,
        ...config,
      })
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
  })
}

export const post = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    instance
      .post(url, data, {
        // headers: {
        //   'CQ-MEMBER-TOKEN': token
        // }
      })
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
  })
}

export const put = (url, data = {}, config = {}) => {
  return new Promise((resolve, reject) => {
    instance
      .put(url, data, {...config})
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
  })
}

export const patch = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    instance
      .patch(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
